import { liteClient as algoliasearch } from 'algoliasearch/lite';

// Create the Algolia search client using the recommended approach from Algolia docs.
// react-instantsearch v7 works directly with algoliasearch v5's liteClient.
//
// For analytics/insights features (userToken, click analytics), use:
// - The `insights` prop on <InstantSearch> component
// - Or createInsightsMiddleware() for more control
//
// See: https://www.algolia.com/doc/api-reference/widgets/instantsearch/react/
export const searchClient = algoliasearch(
    process.env['NEXT_PUBLIC_ALGOLIA_APPLICATION_ID'] || '',
    process.env['NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY'] || ''
);

// Legacy export for backwards compatibility
export { searchClient as algoliaSearchClient };
